import React from 'react'
import { Button, Col, Modal, Row, Select } from 'antd'
import { UserAddOutlined } from '@ant-design/icons'
import PartnerProfileAddContactForm from './PartnerProfileAddContactForm'

const { Option } = Select

class PartnerProfileContactSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      artistId: props.artistId,
      contacts: props.contacts,
      addModalVisible: false,
      addLoading: false
    }
    this.formId = 'partner-profile-add-contact-form'
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      artistId: nextProps.artistId,
      contacts: nextProps.contacts
    })
  }

  onAddContactSuccessfully = (data) => {
    this.setState({ addModalVisible: false })
    this.setState({
      contacts: this.state.contacts.concat({ data })
    })
  }

  render() {
    const { artistId, contacts, ...rest } = this.props
    console.log(artistId, contacts)

    return (
      <Row style={{ margin: 0 }}>
        <Col key={1} span={20}>
          <Select
            placeholder='please select from your contact list'
            {...rest}
            mode={'multiple'}
            allowClear
            showArrow
            defaultActiveFirstOption={false}
          >
            {this.state.contacts.map((v) => {
              return (
                <Option key={v.id} value={v.id}>
                  {'#' + v.id + ' ' + v.first_name + ' ' + v.last_name}
                </Option>
              )
            })}
          </Select>
        </Col>
        <Col key={2} span={2} offset={1}>
          <Button
            onClick={(v) => {
              this.setState({ addModalVisible: true })
            }}
            icon={<UserAddOutlined />}
          />
        </Col>
        <Modal
          title='Contact Info'
          visible={this.state.addModalVisible}
          onOk={() => {
            this.setState({ addModalVisible: false })
          }}
          onCancel={() => {
            this.setState({ addModalVisible: false })
          }}
          footer={[
            <Button
              key='back'
              onClick={() => {
                this.setState({ addModalVisible: false })
              }}
            >
              Cancel
            </Button>,
            <Button form={this.formId} key='submit' htmlType='submit' type='primary' loading={this.state.addLoading}>
              Add
            </Button>
          ]}
        >
          <PartnerProfileAddContactForm
            artistId={this.state.artistId}
            formId={this.formId}
            onFinishSubmit={this.onAddContactSuccessfully}
          />
        </Modal>
      </Row>
    )
  }
}

export default PartnerProfileContactSelect
